import React, { FunctionComponent, useState } from 'react';

import { SegmentedControlOptions } from 'scenes/common/components/Questions';
import { SingleSegmentedControlStep } from 'scenes/common/components/Steps';
import { Finance, MotorFullPageProps } from 'scenes/motor/types';
import { getFinance } from 'scenes/motor/selectors';

import { DifferenceModal } from './DifferenceModal';

export const STATE_KEY = 'finance';
export const QUESTION = 'Is the car under finance?';
export const HELP_TEXT =
  'Includes loans, hire purchase or lease from finance companies, banks or credit unions.';

const FINANCE_OPTIONS: SegmentedControlOptions<Finance, Finance> = [
  { label: Finance.NoFinance, value: Finance.NoFinance },
  { label: Finance.SecuredLoan, value: Finance.SecuredLoan },
  { label: Finance.UnsecuredLoan, value: Finance.UnsecuredLoan },
  { label: Finance.Lease, value: Finance.Lease },
  {
    label: Finance.HirePurchaseArrangement,
    value: Finance.HirePurchaseArrangement,
  },
];

const FinanceStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  onNext,
}) => {
  const [showModal, setShowModal] = useState(false);
  const finance = getFinance(funnelState);
  const helpLink = {
    id: 'difference-link',
    text: 'What is the difference between secured and unsecured loan?',
    ariaLabel:
      'What is the difference between secured and unsecured loan? Opens dialog',
    onClick: () => setShowModal(true),
  };
  return (
    <>
      <SingleSegmentedControlStep
        stack
        onNext={onNext}
        question={QUESTION}
        helpLink={helpLink}
        stateKey={STATE_KEY}
        helpText={HELP_TEXT}
        options={FINANCE_OPTIONS}
        defaultStateValue={finance}
      />
      <DifferenceModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default FinanceStep;
